{
  "title": "Guide des tailles",
  "runsSmallLabel": "Taille petit",
  "trueToSizeLabel": "Taille normalement",
  "runsLargeLabel": "Taille grand",
  "confidenceText": "{value}% de confiance basé sur les retours clients",
  "loading": "Chargement du guide des tailles...",
  "fitCategorySmall": "Taille probablement petit",
  "fitCategoryTrue": "Taille normalement",
  "fitCategoryLarge": "Taille probablement grand",
  "fallbackTruePill": "Probablement taille normalement",
  "noDataPill": "Aucune donnée disponible",
  "errorPill": "Temporairement indisponible",
  "recommendationHeadingSmall": "Envisagez une taille au-dessus",
  "recommendationHeadingTrue": "Devrait convenir comme prévu",
  "recommendationHeadingLarge": "Envisagez une taille en dessous",
  "fallbackTrueHeading": "Devrait convenir comme prévu",
  "fallbackTrueSummary": "Nous n'avons pas encore assez de retours clients pour cet article, cette vue suppose donc une taille normale.",
  "noDataHeading": "Aucune donnée disponible",
  "noDataSummary": "Nous n'avons pas encore assez de retours clients pour cet article.",
  "errorHeading": "Guide des tailles indisponible",
  "errorSummary": "Cette recommandation de taille est temporairement indisponible. Veuillez réessayer plus tard.",
  "fallbackSummarySmall": "Les retours clients suggèrent que cet article pourrait tailler plus petit que prévu.",
  "fallbackSummaryTrue": "Les retours clients suggèrent que cet article devrait convenir comme prévu.",
  "fallbackSummaryLarge": "Les retours clients suggèrent que cet article pourrait tailler plus grand que prévu."
}